import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import { Layout, Typography, Form, Collapse } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import appLabel from "../../../../config/appLabel";
import appStatic from "../../../../config/appStatic";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../components/RecordStatus";
import FixedDepositTabs from "./FixedDepositTabs";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const ViewPRD0300 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const [interestRateTableSource, setInterestRateTableSource] = useState([]);
  const [chargeDataSource, setChargeDataSource] = useState([]);
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [fixedDepositDetails, setFixedDepositDetails] = useState([]);
  const [editing, setEditing] = useState(true); // This is reffering to the 'disabled' API of the the Text Boxes, etc. True means that 'disabled' = true.

  function onEditModeCancel() {
    setEditing(true);
  }

  useEffect(() => {
    // console.log(state);
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    const url = `${definedApi.ViewFixedDeposit}/${params.key}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        let tempInterestRateDataSource = [];
        let tempChargeDataSource = [];
        setFixedDepositDetails(objDetail);

        objDetail?.activeChart?.chartSlabs?.forEach((element) => {
          tempInterestRateDataSource.push({
            key: element?.id,
            id: element?.id,
            amountRangeFrom: element?.amountRangeFrom
              ? Number(element?.amountRangeFrom).toLocaleString()
              : " - ",
            description: element?.description ? element?.description : " - ",
            annualInterestRate: element?.annualInterestRate
              ? element?.annualInterestRate
              : " - ",
            amountRangeTo: element?.amountRangeTo
              ? Number(element?.amountRangeTo).toLocaleString()
              : " - ",
            fromPeriod: element?.fromPeriod ? element?.fromPeriod : " - ",
            toPeriod: element?.toPeriod ? element?.toPeriod : " - ",
            periodType: element?.periodType?.value
              ? element?.periodType?.value
              : " - ",
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargeDataSource.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : " - ",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : " - ",
            amount: element?.amount
              ? Number(element?.amount).toLocaleString()
              : " - ",
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : " - ",
          });
        });

        setInterestRateTableSource(tempInterestRateDataSource);
        setChargeDataSource(tempChargeDataSource);
      }
    });
  };

  //   let action = "Delete  ";
  //   let label = state.financialActivity;
  //   // console.log(body);return

  //   Notiflix.Confirm.show(
  //     "Are you sure?",
  //     action + label,
  //     "Yes",
  //     "No",
  //     function () {
  //       // Yes
  //       const url = `${definedApi.DeleteGLMappingList}/${state.key}`;

  //       const body = {
  //         method: "DELETE",
  //         session,
  //       };

  //       setIsLoading(true);

  //       BOM.FetchReqAction(body, url, (err, res) => {
  //         if (err) {
  //           BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
  //           setIsLoading(false);
  //         } else {
  //           BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteGLMappingMsg);
  //           navigate("/gla0400");
  //           //STOP LOAD
  //           setIsLoading(false);
  //         }
  //       });
  //     },
  //     function () {
  //       // No button
  //     }
  //   );
  // };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={appLabel.FixedDepositDetail}
        pageItems={appStatic.viewFixedDepositItems}
      />

      {/* PART 2 DISPLAY CONTENT */}
      <FixedDepositTabs
        disabled={editing}
        onEditCancel={onEditModeCancel}
        formButtonState={editing}
        fixedDepositDetails={fixedDepositDetails}
        interestRateTableSource={interestRateTableSource}
        chargeDataSource={chargeDataSource}
      />

      {/* PART 3 DISPLAY  RECORD STATUS */}
      <RecordStatus
        authStatus={""}
        makerID={""}
        makerDate={""}
        checkerID={""}
        checkerDate={""}
      />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPRD0300);
